// extracted by mini-css-extract-plugin
module.exports = {"container__legal-info":"content_container__legal-info__F5EID","legal-text":"content_legal-text___oCcD","text-wrapper":"content_text-wrapper__zcaS3"};